import React from 'react';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

/**
 * Shared execution-status badges for workflow nodes. Used by both
 * Canvas Mode (rendered absolutely on the xyflow node) and Simple
 * Mode (rendered in the corner of a step card).
 */
export const EXECUTION_STATUS_STYLES = {
  running: {
    badge: (
      <div className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-gray-700 rounded-full flex items-center justify-center">
        <Loader2 className="w-2.5 h-2.5 text-white animate-spin" />
      </div>
    ),
  },
  completed: {
    badge: (
      <div className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-gray-700 rounded-full flex items-center justify-center">
        <CheckCircle2 className="w-2.5 h-2.5 text-white" />
      </div>
    ),
  },
  failed: {
    badge: (
      <div className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-gray-700 rounded-full flex items-center justify-center">
        <XCircle className="w-2.5 h-2.5 text-white" />
      </div>
    ),
  },
};
